// AdminSubbar retired — workspace pills moved into UserActionBar (variant="admin")
// so the admin nav shares a single row with the widgets bar.
// Stub kept to avoid route/import churn; delete in a later cleanup pass.
function AdminSubbar() {
  return null;
}

export default AdminSubbar;
